module.exports = __webpack_public_path__ + "img/地图配置.5ff42d3e.svg";